export const technicianLeaveList = "TECHNICIAN_LEAVE_LIST";